<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M17.5739 5.81432C16.8656 5.03099 15.6822 4.63932 13.9656 4.63932H13.7656V4.60599C13.7656 3.20599 13.7656 1.47266 10.6322 1.47266H9.36555C6.23223 1.47266 6.23223 3.21432 6.23223 4.60599V4.64766H6.03223C4.30723 4.64766 3.13223 5.03932 2.42389 5.82266C1.59889 6.73932 1.62389 7.97266 1.70723 8.8143L1.71556 8.87263L1.78011 9.55038C1.79199 9.67521 1.85922 9.78796 1.96413 9.85663C2.16396 9.98738 2.49842 10.203 2.69889 10.3143C2.81556 10.3893 2.94056 10.456 3.06556 10.5226C4.49056 11.306 6.05723 11.831 7.64889 12.0893C7.72389 12.8726 8.06556 13.7893 9.89055 13.7893C11.7156 13.7893 12.0739 12.881 12.1322 12.0726C13.8322 11.7976 15.4739 11.206 16.9572 10.3393C17.0072 10.3143 17.0406 10.2893 17.0822 10.2643C17.4128 10.0775 17.7558 9.84721 18.0685 9.62171C18.1626 9.55371 18.2229 9.44871 18.2357 9.3333L18.2489 9.2143L18.2906 8.82263C18.2989 8.77263 18.2989 8.73096 18.3072 8.67263C18.3739 7.83099 18.3572 6.68099 17.5739 5.81432ZM10.9072 11.5226C10.9072 12.406 10.9072 12.5393 9.88222 12.5393C8.85722 12.5393 8.85722 12.381 8.85722 11.531V10.481H10.9072V11.5226ZM7.42389 4.63932V4.60599C7.42389 3.18932 7.42389 2.66432 9.36555 2.66432H10.6322C12.5739 2.66432 12.5739 3.19766 12.5739 4.60599V4.64766H7.42389V4.63932Z"
      fill="currentColor"
    />
    <path
      d="M17.392 11.4439C17.6867 11.3037 18.0261 11.5372 17.9966 11.8622L17.6974 15.1571C17.5224 16.8237 16.8391 18.5237 13.1724 18.5237H6.82244C3.15578 18.5237 2.47244 16.8237 2.29744 15.1654L2.01352 12.0422C1.98432 11.721 2.31595 11.4877 2.60981 11.6207C3.55933 12.0502 5.31194 12.8124 6.39458 13.096C6.53151 13.1318 6.64225 13.2298 6.70221 13.3581C7.20802 14.4398 8.30504 15.0154 9.88908 15.0154C11.4576 15.0154 12.5684 14.4177 13.0759 13.3332C13.1359 13.2049 13.2468 13.1069 13.3838 13.0709C14.5334 12.7684 16.3989 11.9164 17.392 11.4439Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'CorporateTaxpayersIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>